/** Scope local SVG definitions and their references without changing external URLs. */
export function scopeSvgIds(svg: string, instanceId: string): string {
  const ids = new Set(
    [...svg.matchAll(/\bid=["']([^"']+)["']/g)].map((match) => match[1]),
  );
  if (!ids.size) return svg;
  const suffix = instanceId.replace(
    /[&<>"']/g,
    (char) => `&#${char.charCodeAt(0)};`,
  );
  return svg.replace(
    /([\w:-]+)=(["'])(.*?)\2/g,
    (attribute, name, quote, value: string) => {
      let scoped = value;
      if (name === "id" && ids.has(value)) scoped = `${value}-${suffix}`;
      else if (
        (name === "href" || name === "xlink:href") &&
        value.startsWith("#") &&
        ids.has(value.slice(1))
      )
        scoped = `${value}-${suffix}`;
      else
        scoped = value.replace(/url\(#([^)]+)\)/g, (reference, id) =>
          ids.has(id) ? `url(#${id}-${suffix})` : reference,
        );
      return `${name}=${quote}${scoped}${quote}`;
    },
  );
}
